import { action } from 'typesafe-actions';
import { ConsentimentosType } from './types';

export const contratosRequest = () =>
  action(ConsentimentosType.CONTRATO_RESQUEST, {});

export const contratosSuccess = (data: any) =>
  action(ConsentimentosType.CONTRATO_SUCCESS, { data });

export const contratosFailure = () =>
  action(ConsentimentosType.CONTRATO_FAILURE, {});

export const consentimentosRequest = (newPage: any, rowsPerPage: any) =>
  action(ConsentimentosType.CONSENTIMENTOS_RESQUEST, { newPage, rowsPerPage });

export const consentimentosSuccess = (data: any) =>
  action(ConsentimentosType.CONSENTIMENTOS_SUCCESS, { data });

export const consentimentosFailure = () =>
  action(ConsentimentosType.CONSENTIMENTOS_FAILURE, {});

export const getOrderHandleChangeRowsPerPageRequest = (
  newPage: number,
  rowsPerPage: string,
) =>
  action(ConsentimentosType.GET_ORDER_HANDLE_CHANGE_ROWS_PER_PAGE_RESQUEST, {
    newPage,
    rowsPerPage,
  });

export const getOrderHandleChangeRowsPerPageSuccess = (data: any) =>
  action(ConsentimentosType.GET_ORDER_HANDLE_CHANGE_ROWS_PER_PAGE_SUCCESS, {
    data,
  });

export const getOrderHandleChangeRowsPerPageFailure = () =>
  action(ConsentimentosType.GET_ORDER_HANDLE_CHANGE_ROWS_PER_PAGE_FAILURE, {});

export const getOrderHandleChangePageRequest = (
  newPage: number,
  rowsPerPage: number,
) =>
  action(ConsentimentosType.GET_ORDER_HANDLE_CHANGE_PAGE_RESQUEST, {
    newPage,
    rowsPerPage,
  });

export const getOrderHandleChangePageSuccess = (data: any) =>
  action(ConsentimentosType.GET_ORDER_HANDLE_CHANGE_PAGE_SUCCESS, {
    data,
  });

export const getOrderHandleChangePageFailure = () =>
  action(ConsentimentosType.GET_ORDER_HANDLE_CHANGE_PAGE_FAILURE, {});

export const changeStateConsentimentosRequest = (
  personal_consent_policy_id: number,
  personal_id: number | string,
  isActive: string,
  atividade: string,
  codigo: string,
) =>
  action(ConsentimentosType.CHANGE_STATE_CONSENTIMENTOS_RESQUEST, {
    personal_consent_policy_id,
    personal_id,
    isActive,
    atividade,
    codigo,
  });

export const changeStateConsentimentosSuccess = (data: any) =>
  action(ConsentimentosType.CHANGE_STATE_CONSENTIMENTOS_SUCCESS, { data });
interface IPropsPostConsentimentos {
  recaptcha: string;
}
export const postConsentimentosRequest = (config: IPropsPostConsentimentos) =>
  action(ConsentimentosType.POST_CONSENTIMENTOS_RESQUEST, { config });

export const postConsentimentosSuccess = () =>
  action(ConsentimentosType.POST_CONSENTIMENTOS_SUCCESS, {});

export const postConsentimentosFailure = () =>
  action(ConsentimentosType.POST_CONSENTIMENTOS_FAILURE, {});

export const resetConsentimentosSuccess = () =>
  action(ConsentimentosType.RESET_TEMPDATA, {});
